(function () {
    'use strict';

    angular.module('app').controller('ImportCustomersController', ImportCustomersController);

    ImportCustomersController.$inject = [
        '$rootScope',
        '$scope',
        '$filter',
        '$routeParams',
        '$location',
        '$timeout',
        '$q',
        'blockUI',
        '$window',
        'BusinessService',
        'CustomerService',
        'SelectService',
        'SettingsService'
    ];

    function ImportCustomersController(
        $rootScope,
        $scope,
        $filter,
        $routeParams,
        $location,
        $timeout,
        $q,
        blockUI,
        $window,
        BusinessService,
        CustomerService,
        SelectService,
        SettingsService
    ) {
        $scope.getPages = getTotalPaginatedPages;
        $scope.activeImport = false;
        $scope.activeImportGlobal = $window.localStorage.getItem(`${$rootScope.appConfig.platform_key}_import`);

        $scope.model = {
            headerExist: false, skip_transaction_message: true, skip_category_change_message: true
        };

        $scope.params = {
            customers: {
                page: 1, count: 20
            }
        };

        $scope.data = {
            moment_format_parse_list: [false, 'DD.MM.YYYYY', 'MM.DD.YYYYY', 'DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD'],
            moment_format_parse_expire_date: false,
            fields: [
                {
                    id: 'none',
                    title: 'Do not import'
                },
                {

                    id: 'phone',
                    group: 'general',
                    title: 'Customer number'
                },
                {
                    id: 'email',
                    group: 'general',
                    title: 'Customer email'
                },
                {
                    id: 'consent',
                    group: 'general',
                    title: 'Consent'
                }, {
                    id: 'user_name',
                    group: 'general',
                    title: 'Customer name'
                },
                {
                    id: 'user_birth_date',
                    group: 'general',
                    title: 'Birthday'
                }, {
                    id: 'user_gender',
                    group: 'general',
                    title: 'Gender'
                },
                {
                    id: 'access_type',
                    group: 'general',
                    title: 'Access type'
                },
                {
                    id: 'category',
                    group: 'general',
                    title: 'Category'
                },
                {
                    id: 'customer_additional_cards',
                    group: 'general',
                    title: 'Additional cards'
                },
                {
                    id: 'refill_amount',
                    group: 'refill',
                    title: 'TEXT_REFILL_AMOUNT'
                },
                {
                    id: 'refill_currency',
                    group: 'refill',
                    title: 'Currency'
                },
                {
                    id: 'refill_comment',
                    group: 'refill',
                    title: 'TEXT_COMMENT'
                },
                {
                    id: 'expire_date',
                    group: 'refill',
                    title: 'Expires on'
                },
                {
                    id: 'starting_date',
                    group: 'refill',
                    title: 'Refill from'
                },
                {
                    id: 'refill_terminal_id',
                    group: 'refill',
                    title: 'Terminal id'
                },
                {
                    id: 'write_off_amount',
                    group: 'write_off',
                    title: 'TEXT_WRITE_OFF_AMOUNT'
                },
                {
                    id: 'write_off_currency',
                    group: 'write_off',
                    title: 'Currency'
                },
                {
                    id: 'write_off_comment',
                    group: 'write_off',
                    title: 'TEXT_COMMENT'
                },
                {
                    id: 'write_off_account',
                    group: 'write_off',
                    title: 'Customer account'
                },
                {
                    id: 'write_off_terminal_id',
                    group: 'write_off',
                    title: 'Terminal id'
                },
                {
                    id: 'adjust_amount',
                    group: 'adjust',
                    title: 'TEXT_ADJUST_AMOUNT'
                },
                {
                    id: 'adjust_currency',
                    group: 'adjust',
                    title: 'Currency'
                },
                {
                    id: 'adjust_comment',
                    group: 'adjust',
                    title: 'TEXT_COMMENT'
                },
                {
                    id: 'adjust_account',
                    group: 'adjust',
                    title: 'Customer account'
                },
                {
                    id: 'adjust_expire_date',
                    group: 'adjust',
                    title: 'Expires on'
                },
                {
                    id: 'adjust_starting_date',
                    group: 'adjust',
                    title: 'Refill from'
                },
                {
                    id: 'adjust_terminal_id',
                    group: 'adjust',
                    title: 'Terminal id'
                },
            ],
            headers: [],
            imported: null,
            processed: null,
            primary_id_type: 'phone',
            pagerLengths: [10, 20, 50, 100, 200],
            summary: {
                total_rows_count: 0
            }
        };

        $scope.data.primary_id_type_list = [{value: 'phone', title: 'TEXT_PRIMARY_ID_TYPE_PHONE'}, {
            value: 'email',
            title: 'TEXT_PRIMARY_ID_TYPE_EMAIL'
        }];

        $scope.status = {
            file_type: null, import_progress: 0, chunk_size: 50, current_chunk: 0, result: {
                data: {
                    fields: null, rows: []
                }, add: 0, update: 0, error: 0, errors: []
            }
        };

        $scope.error = {
            message: null
        };

        $scope.isPageMode = isPageMode;
        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;

        $scope._pageMode = 'default';

        $rootScope.REQUEST_ABORT_PENDING = false;
        $scope.isSupportUserExternalId = false;

        var block_import_customers = blockUI.instances.get('import_customers');
        SettingsService.GetPlatformParams(function (success, response) {

            if (success) {
                $scope.isSupportUserExternalId = !!response.support_external_id_primary_identifier;

                if ($scope.isSupportUserExternalId) {
                    $scope.data.primary_id_type_list.push({
                        value: 'external-id', title: 'External id'
                    });
                    $scope.data.fields.push({
                        id: 'external_id', title: 'External id', group: 'general'
                    });

                }
            }
            initController();
        });

        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        function initController() {
            getAccountsList();
            getCurrenciesList();
            getCustomerFields();
            getImportPreferences();
            $window.onbeforeunload = function (event) {
                if ($scope.activeImport) {
                    event.preventDefault();
                    event.returnValue = true;
                    $window.localStorage.removeItem(`${$rootScope.appConfig.platform_key}_import`)
                }
            }
        }

        function getImportPreferences() {
            CustomerService.ImportPreferences(function (success, data) {
                if (success) {
                    if (data.primary_id_type) {
                        $scope.data.primary_id_type = data.primary_id_type;
                    }
                }
            });
        }

        function getCustomerFields() {
            CustomerService.CustomerFields(function (success, data) {
                if (success) {
                    data.forEach(function (item) {
                        $scope.data.fields.push({
                            id: item.id, title: item.description, type: item.type, group: 'custom'
                        });
                    });
                }
            });
        }

        function getCurrenciesList() {
            if (!$scope.data.currenciesList || $scope.data.currenciesList.length === 0) BusinessService.CurrencyList(null, function (success, response) {
                if (success) $scope.data.currenciesList = response;
            });
        }

        function getAccountsList() {
            BusinessService.SpecialAccounts(function (success, response) {
                if (success) {
                    $scope.data.specialAccountsList = [];

                    for (var i in response) if (response[i].active === 1) $scope.data.specialAccountsList.push(response[i]);

                    if ($scope.data.specialAccountsList.length > 0) $scope.data.fields.push({
                        id: 'refill_account',
                        group: 'refill',
                        title: 'Customer account'
                    });

                }
            });
        }

        function importData(data) {
            if (!data) return null;

            // $scope.data.imported = angular.copy(data);
            $scope.$apply(function () {
                $scope.data.imported = angular.copy(data);
            });

            processData();
        }

        function processData() {
            console.log('processData');
            if (!$scope.data.imported) return null;

            // if ($scope._pageMode == 'preview') {
            //
            // }
            var block_ui = $scope._pageMode == 'preview' ? blockUI.instances.get('import_customers_preferences') : blockUI.instances.get('import_customers');
            block_ui.start();
            console.log('block_ui', block_ui);
            if ($scope.data.processed) {
                $scope.data.processed.length = 0;
            }
            $scope.data.processed = null;
            $scope.data.summary.total_rows_count = 0;
            $scope.data.headers = [];

            // var promise = processDataCore();

            processDataCore2().then(function (value) {
            }, function (error) {
            }).finally(function () {
                $timeout(function () {
                    block_ui.stop();
                }, 1000);
            });

            // block_ui.stop();
        }

        function processDataCore2() {
            return new Promise(function (resolve, reject) {
                if (!$scope.data.imported) {
                    reject('NO DATA');
                    return;
                }

                var data = null,
                    a = [];

                if (($scope.status.file_type === 'csv' || $scope.status.file_type === 'txt') && Object.keys($scope.data.imported[0]).length === 1 && typeof Object.values($scope.data.imported[0])[0] === 'string' && Object.values($scope.data.imported[0])[0].indexOf(';') !== -1) {
                    data = [];
                    for (var i in $scope.data.imported) {
                        for (var k in $scope.data.imported[i]) {
                            data.push($scope.data.imported[i][k].split(';'));
                        }
                    }
                } else {
                    data = angular.copy($scope.data.imported);
                }


                // Prepare headers
                var props = {}, longest_row = data[0], hdr = null;

                for (var i in data) {
                    if (Object.keys(longest_row).length < Object.keys(data[i]).length) {
                        longest_row = data[i];
                    }
                }

                if ($scope.model.headerExist) {
                    hdr = data.shift();
                }

                for (var i in longest_row) {
                    props[i] = i;

                    var htitle = props[i];
                    if (hdr && hdr[props[i]]) {
                        htitle = hdr[props[i]];
                    }

                    $scope.data.headers.push({title: htitle, field: 'none'});
                }


                // Prepare data for preview
                for (var i in data) {
                    a[i] = [];

                    for (var l in props) {
                        if (data[i][props[l]]) {
                            a[i].push(data[i][props[l]]);
                        } else {
                            a[i].push('');
                        }
                    }
                }

                $scope.data.summary.total_rows_count = a.length;

                $scope.data.processed = angular.copy(a);

                if ($scope.data.processed) {

                    $scope._pageMode = 'preview';
                    // $scope.$apply(function(){
                    //     $scope._pageMode = "preview";
                    // });


                    var d = $scope.data.processed, h = $scope.data.headers, pi = null; // phone column index

                    if (!d || !d[0] || !h) {
                        return null;
                    }

                    if (h.length === 0) {
                        for (var i = 0; i < d[0].length; i++) {
                            h.push({title: '', field: 'none'});
                        }
                    }

                    for (var i in d) {
                        if (!pi) {
                            for (var k in d[i]) {
                                if ($scope.data.primary_id_type === 'email') {
                                    if (typeof d[i][k] === 'string' && isEmailValid(d[i][k])) {
                                        pi = k;
                                    }
                                } else {
                                    if (typeof d[i][k] === 'string' && d[i][k].indexOf('+') === 0) {
                                        pi = k;
                                    } else if (typeof d[i][k] === 'number' && isPhoneValid('+' + d[i][k])) {
                                        pi = k;
                                    }
                                }
                            }
                        } else {
                            break;
                        }
                    }

                    if (pi) {
                        for (var i in h) {
                            if (i === pi) {
                                h[i].field = $scope.data.primary_id_type;
                            }
                        }
                    }

                    resolve('OK');
                    return;


                } else {
                    resolve('OK');
                    return;
                }


            });


        }

        function processDataCore() {

            var deferred = $q.defer();

            $timeout(function () {

                if (!$scope.data.imported) deferred.reject('NO DATA');

                // var data = angular.copy($scope.data.imported);
                var data = null, a = [];

                if (($scope.status.file_type === 'csv' || $scope.status.file_type === 'txt') && Object.keys($scope.data.imported[0]).length === 1 && typeof Object.values($scope.data.imported[0])[0] === 'string' && Object.values($scope.data.imported[0])[0].indexOf(';') !== -1) {

                    data = [];
                    for (var i in $scope.data.imported) {
                        for (var k in $scope.data.imported[i]) {
                            data.push($scope.data.imported[i][k].split(';'));
                        }
                    }
                } else {
                    data = angular.copy($scope.data.imported);
                }

                $timeout(function () {

                    // Prepare headers
                    var props = {}, longest_row = data[0], hdr = null;

                    for (var i in data) {
                        if (Object.keys(longest_row).length < Object.keys(data[i]).length) {
                            longest_row = data[i];
                        }
                    }

                    if ($scope.model.headerExist) {
                        hdr = data.shift();
                    }

                    for (var i in longest_row) {
                        props[i] = i;

                        var htitle = props[i];
                        if (hdr && hdr[props[i]]) {
                            htitle = hdr[props[i]];
                        }

                        $scope.data.headers.push({title: htitle, field: 'none'});
                    }

                    $timeout(function () {
                        // Prepare data for preview
                        for (var i in data) {
                            a[i] = [];

                            for (var l in props) {
                                if (data[i][props[l]]) {
                                    a[i].push(data[i][props[l]]);
                                } else {
                                    a[i].push('');
                                }
                            }
                        }

                        $scope.data.summary.total_rows_count = a.length;

                        $scope.data.processed = angular.copy(a);

                        if ($scope.data.processed) {

                            $scope._pageMode = 'preview';
                            // $scope.$apply(function(){
                            //     $scope._pageMode = "preview";
                            // });

                            $timeout(function () {
                                var d = $scope.data.processed, h = $scope.data.headers, pi = null; // phone column index

                                if (!d || !d[0] || !h) {
                                    return null;
                                }

                                if (h.length === 0) {
                                    for (var i = 0; i < d[0].length; i++) {
                                        h.push({title: '', field: 'none'});
                                    }
                                }

                                for (var i in d) {
                                    if (!pi) {
                                        for (var k in d[i]) {
                                            if ($scope.data.primary_id_type === 'email') {
                                                if (typeof d[i][k] === 'string' && isEmailValid(d[i][k])) {
                                                    pi = k;
                                                }
                                            } else {
                                                if (typeof d[i][k] === 'string' && d[i][k].indexOf('+') === 0) {
                                                    pi = k;
                                                } else if (typeof d[i][k] === 'number' && isPhoneValid('+' + d[i][k])) {
                                                    pi = k;
                                                }
                                            }
                                        }
                                    } else {
                                        break;
                                    }
                                }

                                if (pi) {
                                    for (var i in h) {
                                        if (i === pi) {
                                            h[i].field = $scope.data.primary_id_type;
                                        }
                                    }
                                }

                                deferred.resolve('OK');
                            }, 200, true);

                        } else {
                            deferred.resolve('OK');
                        }
                    }, 200, true);
                }, 200, true);
            }, 200, true);

            return deferred.promise;
        }

        function isValidGender(g) {
            var gs = [{male: ['male', 'мужской', 'чоловік', 'kişi', 'mężczyzna']}, {female: ['female', 'женский', 'жінка', 'qadın', 'kobieta']}, {other: ['other', 'другой', 'інша', 'digər', 'inne']}];

            for (var i in gs) for (var k in gs[i]) if (gs[i][k].indexOf(g.toLowerCase()) !== -1) return k;

            return false;
        }

        function isValidCustomField(f, v) {
            var fs = $scope.data.fields, d, int;
            for (var i in fs) {
                if (fs[i].id === f) {
                    switch (fs[i].type) {
                        case 'date':
                            d = moment(v);
                            if (d.isValid()) return moment(d).format('YYYY-MM-DD');
                            break;
                        case 'integer':
                            if (parseInt(v, 10)) return v;
                        case 'string':
                        case 'dictionary':
                        default:
                            return v;
                    }
                }
            }

            return false;
        }

        $scope.fileChanged = function (event) {

            $scope.activeImportGlobal = $window.localStorage.getItem(`${$rootScope.appConfig.platform_key}_import`);
            if ($scope.activeImportGlobal) {
                return
            }

            var a = event.srcElement.value.split('.');
            $scope.status.file_type = a[a.length - 1];

            //q Reset data
            // getImportPreferences();
            $scope._pageMode = 'default';

            if ($scope.data.imported) {
                $scope.data.imported.length = 0;
            }
            $scope.data.imported = null;

            if ($scope.data.processed) {
                $scope.data.processed.length = 0;
            }
            $scope.data.processed = null;
            // Reset data

            // Reset file options
            $scope.model.skip_transaction_message = true;
            $scope.model.skip_category_change_message = true;

            $scope.model.headerExist = false;
            // Reset file options

            block_import_customers.start();
            $timeout(function () {

                try {
                    alasql.promise('SELECT * FROM FILE(?,{headers:false})', [event]).then(function (data) {
                        block_import_customers.stop();
                        if (data) {

                            if (!!Object.keys) {
                                data = data.filter(function (value) {
                                    return Object.keys(value).length !== 0;
                                });
                            }

                            importData(data);
                        }
                    });

                } catch (e) {
                    block_import_customers.stop();
                }
                // block_import_customers.stop();
                // alasql('SELECT * FROM FILE(?,{headers:false})', [event], function(data) {
                //     block_import_customers.stop();
                //     if (data) {
                //         importData(data);
                //     }
                // });
            }, 200, true);
        };

        $scope.onFileSelect = function () {
            $scope.activeImportGlobal = $window.localStorage.getItem(`${$rootScope.appConfig.platform_key}_import`);
            if ($scope.activeImportGlobal) {
                return
            }
            var file = angular.element(document.getElementById('dataFileInput'));
            file.val(null);

            $scope.error.message = null;
        };
        $scope.onColumnMomentFormatChange = function (index) {

            $scope.onColumnValueChange($scope.data.headers[index].field, index);
        };

        $scope.onColumnValueChange = function (field, index) {
            var r_index, a_index, d_index, c_index;

            for (var i in $scope.data.headers) if (index * 1 !== i * 1 && ($scope.data.headers[i].field === field || (field === 'refill_currency' && $scope.data.headers[i].field === 'refill_account') || (field === 'refill_account' && $scope.data.headers[i].field === 'refill_currency'))) $scope.data.headers[i].field = 'none';

            for (var i in $scope.data.headers) switch ($scope.data.headers[i].field) {
                case 'refill_amount':
                case 'write_off_amount':
                case 'adjust_amount':
                    r_index = i;
                    break;
                case 'refill_account':
                case 'write_off_account':
                case 'adjust_account':
                    a_index = i;
                    break;
                case 'refill_currency':
                case 'write_off_currency':
                case 'adjust_currency':
                    c_index = i;
                    break;
                case 'refill_comment':
                case 'write_off_comment':
                case 'adjust_comment':
                    d_index = i;
                    break;
                case 'expire_date':
                case 'adjust_expire_date':
                    d_index = i;
                    break;
                case 'starting_date':
                case 'adjust_starting_date':
                    d_index = i;
                    break;
            }

            if (r_index) for (var i in $scope.data.processed) if (parseFloat($scope.data.processed[i][r_index])) {
                var v = $scope.data.processed[i][r_index];

                if (v && typeof v === 'string' && (v.match(/,/g) || []).length === 1 && v.indexOf('.') === -1) v = v.replace(',', '.');

                v = Math.floor(parseFloat(v) * 100) / 100;
                $scope.data.processed[i][r_index] = v;
            } else {
                $scope.data.processed[i][r_index] = 0;
            }

            if (a_index) for (var i in $scope.data.processed) if (!$scope.data.processed[i][a_index]) $scope.data.processed[i][a_index] = $scope.data.specialAccountsList[0].id;

            if (c_index) for (var i in $scope.data.processed) if ($scope.data.processed[i][c_index].length === 3) $scope.data.processed[i][c_index] = $scope.data.processed[i][c_index].toUpperCase();

            if (d_index) {
                for (var i in $scope.data.processed) {

                    if (!!$scope.data.moment_format_parse_expire_date) {
                        var d = moment($scope.data.processed[i][d_index], $scope.data.moment_format_parse_expire_date);
                    } else {
                        var d = moment($scope.data.processed[i][d_index]);
                    }

                    if (d.isValid()) $scope.data.processed[i][d_index] = d.toDate();
                }
            }

            $scope.error.message = null;
        };

        $scope.getCellFieldType = function (index) {
            if ($scope.data.headers[index]) return $scope.data.headers[index].field; else return null;
        };

        $scope.unsetExpireDate = function (pi, i) {
            $scope.data.processed[pi][i] = undefined;
        };

        $scope.onImportClick = function () {

            $scope.activeImportGlobal = $window.localStorage.getItem(`${$rootScope.appConfig.platform_key}_import`);
            if ($scope.activeImportGlobal) {
                return
            }

            var pi;
            for (var i in $scope.data.headers) {
                if ($scope.data.primary_id_type === 'email') {
                    if ($scope.data.headers[i].field === 'email') {
                        if (pi) {
                            $scope.error.message = 'TEXT_ERROR_ONLY_ONE_EMAIL_COLUMN_PERMITED';
                            break;
                        } else {
                            pi = i;
                        }
                    }
                } else if ($scope.data.primary_id_type === 'phone') {
                    if ($scope.data.headers[i].field === 'phone') {
                        if (pi) {
                            $scope.error.message = 'TEXT_ERROR_ONLY_ONE_PHONE_COLUMN_PERMITED';
                            break;
                        } else {
                            pi = i;
                        }
                    }
                } else {
                    if ($scope.data.headers[i].field === 'external_id') {
                        if (pi) {
                            $scope.error.message = 'TEXT_ERROR_ONLY_EXTERNAL_ID_COLUMN_PERMITED';
                            break;
                        } else {
                            pi = i;
                        }
                    }
                }
            }

            if (!pi) {
                if ($scope.data.primary_id_type === 'email') {
                    $scope.error.message = 'TEXT_ERROR_EMAIL_COLUMN_REQUIRED';
                } else if ($scope.data.primary_id_type === 'phone') {
                    $scope.error.message = 'TEXT_ERROR_PHONE_COLUMN_REQUIRED';
                } else {
                    $scope.error.message = 'TEXT_ERROREXTERNAL_ID_COLUMN_REQUIRED';
                }
            }

            if (!$scope.error.message) {
                block_import_customers.start();
                $scope._pageMode = 'progress';


                console.log(222222, $scope.data.headers)

                // Prepare post data
                var post_data = {
                    loyalty_id: $scope.data.currentLoyalty.id,
                    fields: [],
                    skip_transaction_message: $scope.model.skip_transaction_message,
                    skip_category_change_message: $scope.model.skip_category_change_message
                }, import_data = [];

                $scope.data.headers.forEach(function (item) {
                    console.log(item)
                    // if(item.field === 'refill') {
                    //     post_data.fields.push('refill_amount', 'refill_currency', 'refill_comment', 'expire_date', 'starting_date');
                    // } else if(item.field === 'refill-account') {
                    //     post_data.fields.push('refill_amount', 'refill_comment', 'refill_account');
                    // } else if (item.field !== 'none') {
                    //     post_data.fields.push(item.field);
                    // }

                    if (item.field !== 'none') {
                        post_data.fields.push(item.field);
                    }
                });

                console.log('post_data', post_data);

                for (var i in $scope.data.processed) {
                    if (!import_data[i]) import_data[i] = [];

                    for (var k in $scope.data.processed[i]) {
                        var f = $scope.data.headers[k].field, v = $scope.data.processed[i][k];

                        if (f !== 'none') {
                            if (f === 'phone' && v && v.toString().indexOf('+') === -1) v = '+' + v;

                            if (f === 'external_id' && v) v = v.toString();

                            if (f === 'customer_additional_cards' && v) v = v.toString();

                            if (f === 'user_gender' && v && isValidGender(v)) v = isValidGender(v);

                            if (f === 'refill_amount' && v && parseFloat(v)) v = parseFloat(v).toString();

                            if(v && parseFloat(v) && (f === 'refill_amount' || f === 'adjust_amount'  || f === 'write_off_amount' )) {
                                v = parseFloat(v).toString();
                            }

                            if ((f === 'user_birth_date' || f === 'expire_date') || f === 'starting_date' && v) {
                                var d = moment(v);

                                if (d.isValid()) {
                                    v = moment(d).format('YYYY-MM-DD');
                                }

                            }

                            if (f && v && isValidCustomField(f, v)) v = isValidCustomField(f, v);

                            if (!v) v = '';

                            import_data[i].push(v);
                        }
                    }
                }

                $scope.status.total_elements = import_data.length;

                var chunk = import_data.splice(0, $scope.status.chunk_size);

                post_data.customers = chunk;

                $scope.status.import_progress = 0;

                $window.localStorage.setItem(`${$rootScope.appConfig.platform_key}_import`, 'active')
                $scope.activeImport = true;

                var handleResult = function (success, data) {

                    if (success) {
                        if (!$scope.status.result.data.fields) {
                            $scope.status.result.data.fields = data.result.fields;
                        }
                        $scope.status.result.data.rows = $scope.status.result.data.rows.concat(data.result.rows);

                        $scope.status.result.add += data.add;
                        $scope.status.result.error += data.error;
                        $scope.status.result.update += data.update;

                        for (var i in data.errors) {
                            $scope.status.result.errors.push({
                                message: data.errors[i].error_str,
                                row: data.errors[i].row + $scope.status.chunk_size * $scope.status.current_chunk + 1,
                                value: post_data.customers[data.errors[i].row - 1]
                            });
                        }
                    }

                    if (!$rootScope.REQUEST_ABORT_PENDING) {
                        if (success) {
                            $scope.status.import_progress += chunk.length / $scope.status.total_elements * 100;

                            if (import_data.length > 0) {
                                ++$scope.status.current_chunk;

                                chunk = import_data.splice(0, $scope.status.chunk_size);
                                post_data.customers = chunk;
                                CustomerService.Import(post_data, handleResult);
                            } else {
                                $scope._pageMode = 'result';
                                $window.localStorage.removeItem(`${$rootScope.appConfig.platform_key}_import`)
                                $scope.activeImport = false;
                                block_import_customers.stop();
                            }
                        } else {
                            $scope._pageMode = 'result';
                            $window.localStorage.removeItem(`${$rootScope.appConfig.platform_key}_import`)
                            $scope.activeImport = false;
                            block_import_customers.stop();
                        }
                    } else {
                        $rootScope.REQUEST_ABORT_PENDING = false;
                        block_import_customers.stop();
                        $window.localStorage.removeItem(`${$rootScope.appConfig.platform_key}_import`)
                        $scope.activeImport = false;
                        $scope._pageMode = 'result';
                    }

                };

                post_data.primary_id_type = $scope.data.primary_id_type;

                CustomerService.Import(post_data, handleResult);
            }
        };

        $scope.onProcessAbort = function () {
            block_import_customers.start();
            $rootScope.REQUEST_ABORT_PENDING = true;
        };

        $scope.onImportAgainClick = function () {
            $scope._pageMode = 'default';

            $scope.data.headers = [];
            $scope.data.processed = null;

            $scope.status = {
                import_progress: 0, chunk_size: 50, current_chunk: 0, result: {
                    data: {
                        fields: null, rows: []
                    }, add: 0, update: 0, error: 0, errors: []
                }
            };
            block_import_customers.stop();
        };

        $scope.onErrosLogExport = function (format) {
            var file_name = $rootScope.ENV.business.code + '_import_errors_' + moment().format('YYYY-MM-DD_HH:mm:ss');

            switch (format) {
                case 'XLSX':
                    alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [$scope.status.result.errors]);
                    break;
                case 'XLS':
                    alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [$scope.status.result.errors]);
                    break;
                case 'CSV':
                    alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [$scope.status.result.errors]);
                    break;
            }
        };

        $scope.downloadResultImport = function (format) {
            var file_name = $rootScope.ENV.business.code + '_result_import_' + moment().format('YYYY-MM-DD_HH:mm:ss');
            var rows = [];
            rows = rows.concat([$scope.status.result.data.fields]);
            rows = rows.concat($scope.status.result.data.rows);

            switch (format) {
                case 'XLSX':
                    alasql('SELECT * INTO XLSX("' + file_name + '.xlsx",{headers:true}) FROM ?', [rows]);
                    break;
                case 'XLS':
                    alasql('SELECT * INTO XLS("' + file_name + '.xls",{headers:true}) FROM ?', [rows]);
                    break;
                case 'CSV':
                    alasql('SELECT * INTO CSV("' + file_name + '.csv",{headers:true, separator:","}) FROM ?', [rows]);
                    break;
            }
        };

        $scope.getCurrentBlock = function (data) {
            var p = $scope.params.customers.page, c = $scope.params.customers.count;

            return data.slice((p - 1) * c, p * c);
        };

        $scope.pageChange = function () {

        };

        $scope.onCountChange = function (count) {
            $scope.params.customers.page = 1;
            $scope.params.customers.count = count;
        };

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                var saved_loyalty;

                if ($rootScope.ENV.filters.customers_list && $rootScope.ENV.filters.customers_list.loyalty_id) saved_loyalty = itemByIndex($scope.data.loyaltiesList, $rootScope.ENV.filters.customers_list.loyalty_id);

                if (saved_loyalty && saved_loyalty.active === 1) {
                    $scope.data.currentLoyalty = saved_loyalty;
                } else {
                    $scope.data.currentLoyalty = getFirstActive($scope.data.loyaltiesList);
                }
            }
        });

        $scope.$watch('data.currentLoyalty', function (newValue, oldValue) {
            if (newValue) {
                $scope.data.currentLoyalty = newValue;
                $rootScope.ENV.filters.customers_list = {
                    loyalty_id: newValue.id
                };
                $rootScope.storeENV();
            }
        }, true);

        // $scope.$watch('model.headerExist', function(newValue, oldValue) {
        $scope.$watchGroup(['model.headerExist', 'data.primary_id_type', 'data.moment_format_parse_expire_date'], function (newValue, oldValue) {
            console.log('$watchGroup', newValue, $scope._pageMode, $scope.data.imported);
            if ($scope._pageMode == 'preview') {
                if ($scope.data.imported) {
                    processData();
                }
            }
        }, true);

        $scope.$on("$locationChangeStart", function (event) {
            if ($scope.activeImport) {
                if (!confirm($filter('translate')('import_page_leave'))) {
                    event.preventDefault();
                    return;
                }
                $scope.onProcessAbort();
            }
        });
    }
})();
